import React, { FC, useEffect, useState } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import * as csv from "csvtojson";
import { Parser } from "json2csv";

import { DistrictUtil, useAsync } from "../../../utils";
import { ISearchEsProduct, searchInventory } from "../../../api";

enum requiredHeadersEnum {
	productId = "ID sản phẩm",
    pkgName = "Loại đóng gói",
    area = "Khu vực",
    pkgId = "ID đóng gói"
}

enum outputHeadersEnum {
	medigoId = "ID sản phẩm",
	name = "Tên sản phẩm",
	pkgName = "Loại đóng gói",
	topPrice = "Top {replaceMe} giá",
    topPharmacy = "Top {replaceMe} NT"
}

const requiredHeaders = Object.values(requiredHeadersEnum);

const MinPriceProduct: FC = () => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [loadingPercent, setLoadingPercent] = useState<number>(0);
	const [selectedFile, setSelectedFile] = useState<File | null>(null);
	const [isSuccess, setIsSuccess] = useState<boolean>(false);
	const [searchSize, setSearchSize] = useState<number>(3);

	const [csvInfo, setCsvInfo] = useState<{
		headers: string[];
		rows: any[];
		errors: string[];
	}>({
		headers: [],
		rows: [],
		errors: [],
	});
	const [outRows, setOutRows] = useState<any[]>([]);

	const searchInventoryAsync = useAsync(searchInventory);

	useEffect(() => {
		let savedSize = localStorage.getItem("autoMappingSearchSize");
		if (savedSize) {
			setSearchSize(parseInt(savedSize));
		}
	}, []);

	const getQuery = ({ search, area, pkgId, from, size }: any) => {
		return {
			from,
			size,
			query: {
				bool: {
					filter: [
						{
							term: {
								mProductId: search,
							},
						}
						// ,{
						// 	bool: {
						// 		should: getAreaQuery(area),
						// 	},
						// },
					],
				},
			},
            sort: {
                "mDataForSort.mPrice": {
                    unmapped_type: "long",
                    order: "asc",
                    nested_path: "mDataForSort",
                    nested_filter: {
                        term: {
                            "mDataForSort.mPackageId": pkgId
                        }
                    }
                }
            }
		};
	};

    const getAreaQuery = (area: string) => {

        let citiesName: string[] = [];

        if (area === 'HCM') {
            citiesName = DistrictUtil.cities.hochiminh;
        } else if (area === 'HN') {
            citiesName = DistrictUtil.cities.hanoi;
        }else {
            return [];
        }
        
        let should: any[] = [];
        
        should = should.concat(citiesName.map((city) => {
            return {
                match_phrase: {
                    "mPharmacy.mPharmacyAddress.mAddress": city
                },
            };
        }));

        should = should.concat(citiesName.map((city) => {
            return {
                match_phrase: {
                    "mPharmacy.mPharmacyAddress.mAdministrativeAreaLevel1": city
                },
            };
        }))

        return should;
        
    }

	const onFileChange = (files: FileList | null) => {
		if (!files || files.length === 0) {
			return;
		}
		let file = files[0];

		setSelectedFile(file);
		setIsSuccess(false);

		const reader = new FileReader();
		reader.onload = (e) => {
			if (e.target) {
				const text = e.target.result;
				if (text && typeof text === "string") {
					processCSV(text);
				}
			}
		};
		reader.readAsText(file);
	};

	const processCSV = async (str: string) => {
		const rows = await csv.default().fromString(str);
		let headers: string[] = [];

		if (rows && rows.length > 0) {
			for (let key in rows[0]) {
				headers.push(key);
			}
		}

		console.log(rows);

		let errors = [];

		if (!isValidHeader(headers)) {
			errors.push(`Cần có đủ các cột: ${requiredHeaders.join(", ")}`);
		}

		if (!rows || rows.length === 0) {
			errors.push(`Không tìm thấy dữ liệu, vui lòng kiểm tra lại`);
		}

		setCsvInfo({
			headers,
			rows,
			errors,
		});
	};

	const isValidHeader = (headers: string[]) => {
		for (let col of requiredHeaders) {
			let temp = headers.includes(col);
			if (!temp) {
				return false;
			}
		}
		return true;
	};

	const handleSeach = async (value: string, area: string, pkgId: string) => {
		const params = {
			from: 0,
			size: 10,
			search: value,
            area: area,
            pkgId: pkgId
		};
		try {
			let res = await searchInventoryAsync.execute(getQuery(params));
            console.log('res.data: ', res.data);
			return res.data;
		} catch (err) {
			console.log("error: ", err);
		}
	};

	const onUploadClick = async () => {
		if (isLoading || csvInfo.errors.length > 0 || !selectedFile) {
			return;
		}

		setIsLoading(true);

		let totalItems = csvInfo.rows.length;

		console.log("total items: ", totalItems);

		let outRows: any[] = [];

		for (let i = 0; i < totalItems; ++i) {
            
			setLoadingPercent(Math.floor(((i + 1) * 100) / totalItems));

			let row = csvInfo.rows[i];

			let inventoryItems = await handleSeach(
				row[requiredHeadersEnum.productId],
                row[requiredHeadersEnum.area],
                row[requiredHeadersEnum.pkgId]
			);

            if (!inventoryItems || (inventoryItems && inventoryItems.length == 0)){
                outRows.push(Object.assign({}, row));
                continue;
            }

            // Get package id
            let pkgId = inventoryItems[0].mProduct.dong_goi.find((item) => item.loai_dong_goi.name === row[requiredHeadersEnum.pkgName])?.id;

            // sort inventory items
            inventoryItems?.sort((a, b) => {
                let price1 = a.mData.find((item) => item.mPackageId === pkgId)?.mPrice as number;
                let price2 = b.mData.find((item) => item.mPackageId === pkgId)?.mPrice as number;
                return price1 - price2;
            })

            console.log('inventoryItems: ', inventoryItems);

			for (let j = 0; j < searchSize; j++) {	
                if (j > inventoryItems.length - 1){
                    break;
                }
                row[replaceString(outputHeadersEnum.topPrice, (j + 1).toString())] = inventoryItems[j].mData[0].mPrice;
                row[replaceString(outputHeadersEnum.topPharmacy, (j + 1).toString())] = inventoryItems[j].mPharmacy.mName;
			}

            outRows.push(Object.assign({}, row));

		}

		console.log("rows: ", outRows);
		setOutRows(outRows);

		setIsLoading(false);
		setIsSuccess(true);
	};

	const replaceString = (str: string, value: string): string => {
		return str.replace("{replaceMe}", value);
	};

	const getDisableClass = () => {
		if (isLoading || !selectedFile || csvInfo.errors.length > 0) {
			return "disabled";
		}

		return "";
	};

	const FileErrors = () => {
		let maps = csvInfo.errors.map((error, index) => {
			return (
				<div className="alert alert-danger" key={index}>
					<img
						alt="none"
						src="./images/report_problem.svg"
						title="Error"
						className="img-fluid"
						width="20"
					/>
					<span className="ml-2">{error}</span>
				</div>
			);
		});

		return <div>{maps}</div>;
	};

	const handleChangeSearchSize = (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		console.log(e.target.value);
		let value = parseInt(e.target.value);
		if (isNaN(value)) {
			value = 0;
		}
		localStorage.setItem("searchSize", "" + value);
		setSearchSize(value);
	};

	const downloadFile = () => {
		if (!selectedFile || outRows.length == 0) {
			return;
		}

		let parser = new Parser();
		let csv = parser.parse(outRows);

		var blob = new Blob([csv], { type: "text/csv;charset=utf8;" });

		var uri = "data:attachment/csv;charset=utf-8," + encodeURI(csv);
		var link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.setAttribute("visibility", "hidden");
		link.download = selectedFile.name;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<div>
			<LoadingOverlay
				active={isLoading}
				spinner
				text={"Đang xử lý ... " + loadingPercent + "%"}
				fadeSpeed={500}
			>
				{isLoading ? <div className="overlay-wrapper"></div> : ""}
			</LoadingOverlay>

			<div className="management-content">
				<div className="my-3">
					<div className="input-group">
						<div className="input-group-prepend">
							<span
								className="input-group-text"
								id="basic-addon3"
							>
								Top nhà thuốc giá thấp
							</span>
						</div>
						<input
							type="number"
							className="form-control"
							id="basic-url"
							aria-describedby="basic-addon3"
							value={searchSize}
							onChange={handleChangeSearchSize}
						/>
					</div>
				</div>
				<div className="form-group form-file">
					<input
						type="file"
						id="imgInp"
						name="img"
						accept=".csv"
						onChange={(e) => onFileChange(e.target.files)}
					/>
					<span className="input-label">
						<img
							alt="none"
							src="./images/MDI-upload.svg"
							title="Tải lên"
							className="img-fluid"
							width="24"
						/>{" "}
						<span>Tải File/Upload sản phẩm</span>
					</span>
				</div>
			</div>

			{selectedFile ? (
				<div>
					<p>
						Tên file: <span>{selectedFile.name}</span>
					</p>
					<p>
						Số lượng sản phẩm:{" "}
						{new Intl.NumberFormat().format(csvInfo.rows.length)}
					</p>
					<FileErrors />
				</div>
			) : (
				""
			)}

			{isSuccess ? (
				<div className="text-center mt-5 text-success">
					Xử lý dữ liệu thành công
					<button className="btn m-3 px-3" onClick={downloadFile}>
						Tải file
					</button>
				</div>
			) : (
				""
			)}

			<div className="fixed-button">
				<a
					onClick={(e) => {
						e.preventDefault();
						onUploadClick();
					}}
					className={`btn btn-block ${getDisableClass()}`}
					href="/#"
				>
					XỬ LÝ FILE
				</a>
			</div>
		</div>
	);
};

export default MinPriceProduct;
